// Google Analytics (gtag) – wird NUR geladen wenn analytics-Consent erteilt
import { useEffect } from "react";
import { hasConsent } from "../utils/consent";

const GA_ID = "G-SK484C4BF5";

let loaded = false;

function loadGtag() {
  if (loaded) return;
  loaded = true;

  // Script tag
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // Init
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export default function Analytics() {
  useEffect(() => {
    const check = () => {
      if (hasConsent("analytics")) loadGtag();
    };
    check();
    window.addEventListener("consent-changed", check);
    return () => window.removeEventListener("consent-changed", check);
  }, []);
  return null;
}
